<ui-toast />
<ui-confirm-dialog />
<div
  class="flex flex-col h-dvh overflow-hidden px-2 pb-2"
  style="background: var(--canvas-bg)"
>
  <ui-header>
    <!-- The lockup is the way home: it returns to the schedule of the workspace
         the URL already carries, or lets the landing guard pick one where there
         is still no workspace. -->
    <a
      headerBrand
      [routerLink]="brandLink()"
      class="rounded-md focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary"
    >
      <ui-brand class="text-3xl" />
    </a>
    <cl-topbar-user />
  </ui-header>

  <cl-impersonation-banner />

  <!-- No context bar: each page carries its own heading and its own way back —
       the settings menu in its sidenav, the profile in its page header, the
       schedule inline beside the month picker. -->

  <main class="flex flex-col flex-auto min-h-0 overflow-hidden">
    <ng-content />
  </main>
</div>
